import {
  Box,
  Text,
  Stack,
  Button,
  Heading,
  Spinner,
  AbsoluteCenter,
} from "@chakra-ui/react";
import { redirect } from "react-router-dom";
import { useIsMutating } from "@tanstack/react-query";

import { useLoginFormStore } from "../../store/loginFormStore";
import { ESMSFormState } from "../../store/slices/smsFormSliceCreator.ts";
import { EPhoneFormState } from "../../store/slices/phoneFormSliceCreator";
import { isNewAuthorization, useAuthorizationStore } from "../../store/authorizationStore";
import { SMSResendTimer } from "../../components/features/LoginPage";
import { SMSForm } from "../../components/features/LoginPage/SMSForm";
import { usePhoneFormState } from "../../components/features/LoginPage/PhoneNumberForm/hooks";
import { useSMSFormState, useSMSFormStateReaction } from "../../components/features/LoginPage/SMSForm/hooks";

export function OtpPage() {
  const resending = useIsMutating({ mutationKey: ["requestOTP"] }) > 0;
  const phoneForm = usePhoneFormState();
  const smsForm = useSMSFormState();
  useSMSFormStateReaction();

  const handleSubmit = (): void => {
    if (isNewAuthorization() && resending) {
      return;
    }

    if (smsForm.formState === ESMSFormState.initial) {
      smsForm.setFormState(ESMSFormState.validating);
    }
  };

  // const isButtonEnabled = (smsForm.consents).includes("PERSONAL_DATA",) && (smsForm.consents).includes("CREDIT_HISTORY",);

  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={5} minW="300px" pb="100px">
          <div>
            <Heading mb={1} textAlign="center">Введите код из SMS</Heading>
            <Text size="sm" align="center">
              Отправили код на
              {" "}
              {phoneForm.phone}
            </Text>
          </div>
          <SMSForm />
          {/* <Box mt={4}> */}
          {/*  <CheckboxGroup */}
          {/*    value={smsForm.consents} */}
          {/*    onChange={(values: (string | number)[],) => { */}
          {/*      const stringValues: string[] = values.filter((v,): v is string => typeof v === "string",); */}
          {/*      (smsForm.setConsents as (consents: string[]) => void)(stringValues,); */}
          {/*    }} */}
          {/*  > */}
          {/*    <VStack direction={["column", "row",]} spacing={4} alignItems="start"> */}
          {/*      <Checkbox value="PERSONAL_DATA" color="gray.600" display="flex"> */}
          {/*        <Text as="span" fontSize="sm">Соглашаюсь на</Text> */}
          {/*        {" "} */}
          {/*        <Link fontSize="sm" href={VITE_CONSENT_PERSONAL_DATA_URL} textDecoration="underline" onClick={(e,) => { e.stopPropagation(); }}> */}
          {/*          обработку моих персональных данных */}
          {/*        </Link> */}
          {/*        <Text as="span" variant="red">*</Text> */}
          {/*      </Checkbox> */}
          {/*      <Checkbox value="CREDIT_HISTORY" color="gray.600"> */}
          {/*        <Text as="span" fontSize="sm" variant="brand">Соглашаюсь на</Text> */}
          {/*        {" "} */}
          {/*        <Link fontSize="sm" href={VITE_CONSENT_CREDIT_HISTORY_URL} textDecoration="underline" onClick={(e,) => { e.stopPropagation(); }}> */}
          {/*          запрос и получение моей кредитной истории */}
          {/*        </Link> */}
          {/*        <Text as="span" variant="red">*</Text> */}
          {/*      </Checkbox> */}
          {/*      <Checkbox value="MAILING_LIST" color="gray.600" onClick={(e,) => { e.stopPropagation(); }}> */}
          {/*        <Text as="span" fontSize="sm" variant="brand">Соглашаюсь на</Text> */}
          {/*        {" "} */}
          {/*        <Link fontSize="sm" href={VITE_CONSENT_MAILING_LIST_URL} textDecoration="underline"> */}
          {/*          получение сообщений об акциях, продуктах, услугах */}
          {/*        </Link> */}
          {/*      </Checkbox> */}
          {/*    </VStack> */}
          {/*  </CheckboxGroup> */}
          {/* </Box> */}
          <Button mt={1} colorScheme="brand" onClick={handleSubmit} isLoading={isNewAuthorization() && (resending || smsForm.formState !== ESMSFormState.initial)}>
            {smsForm.formState === ESMSFormState.initial
              ? "Продолжить"
              : <Spinner variant="white" />}
          </Button>

          <SMSResendTimer />
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

OtpPage.loader = () => {
  if (isNewAuthorization()) {
    const auth = useAuthorizationStore.getState();
    return auth.otpSessionUuid ? null : redirect("/login");
  }

  const formState = useLoginFormStore.getState();

  if (formState.phoneFormState !== EPhoneFormState.submitted) {
    return redirect("/login");
  }

  formState.clearSMSForm();
  return null;
};
